/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Maximum length of text to display in a segment.
 * @export
 */
export const MAX_CHARACTERS = 80;
